import { styled } from 'styled-components';
import { theme } from '@policygenius/mortar';

export const Card = styled.div`
  border: 1px solid ${theme.colors.gray200};
  padding: 16px;
`;
